import { render, staticRenderFns } from "./c-wizard-radio-form.vue?vue&type=template&id=3424a694&scoped=true&"
import script from "./c-wizard-radio-form.vue?vue&type=script&lang=js&"
export * from "./c-wizard-radio-form.vue?vue&type=script&lang=js&"
import style0 from "./c-wizard-radio-form.vue?vue&type=style&index=0&id=3424a694&lang=scss&scoped=true&"
import style1 from "./c-wizard-radio-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424a694",
  null
  
)

export default component.exports